import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { LearnerAuthProvider } from "./context/LearnerAuthContext";
import { PlacementAuthProvider } from "./context/PlacementAuthContext";
import { ColdCallAuthProvider } from "./context/ColdCallAuthContext";
import { Toaster } from "./components/ui/sonner";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import AdminPage from "./pages/AdminPage";
import CandidateDetailPage from "./pages/CandidateDetailPage";
import LearnCommunicationLanding from "./pages/LearnCommunicationLanding";
import LearnerDashboard from "./pages/LearnerDashboard";
import DailyTaskPage from "./pages/DailyTaskPage";
import PlacementAILanding from "./pages/PlacementAILanding";
import PlacementAIDashboard from "./pages/PlacementAIDashboard";
import ColdCallLabLanding from "./pages/ColdCallLabLanding";
import ColdCallLabDashboard from "./pages/ColdCallLabDashboard";
import PublicAssessmentPage from "./pages/PublicAssessmentPage";

function App() {
  return (
    <AuthProvider>
      <LearnerAuthProvider>
        <PlacementAuthProvider>
          <ColdCallAuthProvider>
            <div className="App">
              <Toaster position="top-right" richColors />
              <BrowserRouter>
                <Routes>
                  {/* HFS Hiring Portal Routes */}
                  <Route path="/" element={<HomePage />} />
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/admin" element={<AdminPage />} />
                  <Route path="/candidate/:id" element={<CandidateDetailPage />} />
                  
                  {/* Learn Communication Routes */}
                  <Route path="/learn-communication" element={<LearnCommunicationLanding />} />
                  <Route path="/learn-communication/dashboard" element={<LearnerDashboard />} />
                  <Route path="/learn-communication/day/:dayNumber" element={<DailyTaskPage />} />
                  
                  {/* Placement AI Routes */}
                  <Route path="/placement-ai" element={<PlacementAILanding />} />
                  <Route path="/placement-ai/dashboard" element={<PlacementAIDashboard />} />
                  
                  {/* Cold Call Lab Routes */}
                  <Route path="/cold-call-lab" element={<ColdCallLabLanding />} />
                  <Route path="/cold-call-lab/dashboard" element={<ColdCallLabDashboard />} />

                  {/* Public Assessment Route (no auth) */}
                  <Route path="/assessment/:slug" element={<PublicAssessmentPage />} />
                </Routes>
              </BrowserRouter>
            </div>
          </ColdCallAuthProvider>
        </PlacementAuthProvider>
      </LearnerAuthProvider>
    </AuthProvider>
  );
}

export default App;
